import queryString from 'query-string';
import { baseUrl, cookieName } from './config';

function getCookie(name) {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop().split(';').shift();
}

async function request(
  endpoint,
  method = 'GET',
  data = {},
  isToken = false,
  formData = false,
) {
  return new Promise((resolve, reject) => {
    let qs = '';
    let body;
    let headers;
    if (['GET', 'DELETE'].indexOf(method) > -1) {
      qs = `${queryString.stringify(data)}`;
    } else if (formData) {
      body = data;
    } else {
      body = queryString.stringify(data);
    }

    if (formData) {
      headers = {
        Accept: 'application/json',
      };
    } else {
      headers = {
        Accept: 'application/json',
        'Content-Type': 'application/x-www-form-urlencoded',
      };
    }

    // Load balancer logic
    // Load balanced server will not be able to access cookies
    if(cookieName && getCookie(cookieName)) {
      headers.Authorization = decodeURIComponent(getCookie(cookieName));
      // This header is used to route our load balancer
      headers.Location = getCookie('location');
    }

    const requestUrl = `${baseUrl}${endpoint}${qs}`;
    const options = {
      method,
      headers,
      credentials: 'include',
      body,
    };

    if (isToken) {
      options.headers.Authorization = `Bearer ${localStorage.getItem('accessToken')}`;
    }

    fetch(requestUrl, options) // eslint-disable-line
      .then(result => result.json())
      .then(json => {
        if (json.message === 'error') {
          reject(json);
        } else {

          resolve(json);
        }
      })
      .catch(err => {
        reject(err);
      });
  });
}

export default request;
